import { removeRedundantObjects } from 'utils/group';
import {
  listContributorTypes,
  listContributions,
  createContribution,
  deleteContribution,
} from '../thunks/contributions';
import { handleFulfilled, handlePending, handleRejected } from './utils';

export const contributionsReducers = (builder) => {
  // list contributor types enum
  builder
    .addCase(listContributorTypes.fulfilled, (state, action) => handleFulfilled(state, 'contributorTypes', action))
    .addCase(listContributorTypes.pending, (state) => handlePending(state, 'contributorTypes'))
    .addCase(listContributorTypes.rejected, (state) => handleRejected(state, 'contributorTypes'));

  //list contributions
  builder
    .addCase(listContributions.fulfilled, (state, action) => {
      const { propertyId, data } = action.payload;

      state.propertyQuotes.value[propertyId] = {
        quotes: state.propertyQuotes.value[propertyId]?.quotes || [],
        contributions: data?.length ? data.map((contribution) => ({ ...contribution })) : [],
      };

      state.contributions.loading[propertyId] = false;
    })
    .addCase(listContributions.pending, (state, action) => {
      const propertyId = action.meta.arg.propertyId;
      state.contributions.loading[propertyId] = true;
    })
    .addCase(listContributions.rejected, (state, action) => {
      const propertyId = action.meta.arg.propertyId;
      state.contributions.loading[propertyId] = false;
    });
  // create contribution
  builder
    .addCase(createContribution.fulfilled, (state, action) => {
      const contribution = action.payload;
      const { property_id } = contribution;

      const updatedContributions = [...state.propertyQuotes.value[property_id].contributions, contribution];
      state.propertyQuotes.value[property_id].contributions = removeRedundantObjects({
        array: updatedContributions,
        property: 'id',
      });

      state.contributions.addLoading[property_id] = false;
      state.contributions.error = null;
    })
    .addCase(createContribution.pending, (state, action) => {
      const propertyId = action.meta.arg.propertyId;
      if (!state.contributions.addLoading) state.contributions.addLoading = {};
      state.contributions.addLoading[propertyId] = true;
      state.contributions.error = null;
    })
    .addCase(createContribution.rejected, (state, action) => {
      const propertyId = action.meta.arg.propertyId;
      state.contributions.addLoading[propertyId] = false;
      state.contributions.error = action.payload || 'Failed to create contribution';
    });

  //delete contribution
  builder
    .addCase(deleteContribution.fulfilled, (state, action) => {
      const { propertyId, id } = action.payload;

      const existingContributions = state.propertyQuotes.value[propertyId]?.contributions || [];

      state.propertyQuotes.value[propertyId] = {
        ...state.propertyQuotes.value[propertyId],
        contributions: existingContributions.filter((contribution) => contribution.id !== id),
      };
      state.contributions.deleteLoading = false;
    })
    .addCase(deleteContribution.pending, (state) => {
      state.contributions.deleteLoading = true;
    })
    .addCase(deleteContribution.rejected, (state) => {
      state.contributions.deleteLoading = false;
    });
};
